/**
 * Changes tabs to accordions on the WooCommerce product page.
 */
(() => {
    let containers = document.querySelectorAll('.woocommerce-tabs');

    if (!containers.length) {
        return;
    }

    /**
     * Whether or not to have the first accordion item open on page load.
     */
    const firstOpen = false;

    function get_title(panel, container) {
        const id = panel.getAttribute('aria-labelledby');

        if (id === null) {
            return '';
        }

        const el = container.querySelector('#' + id + ' a');

        if (!el) {
            return '';
        }

        return el.innerHTML;
    }

    containers.forEach((container) => {
        let panels = document.querySelectorAll('.woocommerce-tabs .panel');

        let isFirst = firstOpen;

        if (!panels.length) {
            return;
        }

        panels.forEach((panel) => {
            let h = document.createElement('h2');
            h.innerHTML = get_title(panel, container);

            let button = document.createElement('button');
            button.classList.add('woocommerce__tab_to_accordion__button');
            button.classList.add('js-accordion-button');
            button.setAttribute('aria-expanded', isFirst ? 'true' : 'false');
            button.append(h);

            let wrapper = document.createElement('div');
            wrapper.classList.add('woocommerce__tab_to_accordion__container');

            panel.removeAttribute('aria-labelledby');
            panel.removeAttribute('role');
            panel.parentNode.insertBefore(button, panel);
            panel.parentNode.insertBefore(wrapper, panel);
            wrapper.append(panel);

            isFirst = false;
        });

        H_Tools?.accordions?.enableAccordions(container);
    });
})();
